
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';

const ZerodhaConnectionHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('request_token')) {
      const requestToken = params.get('request_token');
      console.log('Zerodha token detected on dashboard page:', requestToken);
      
      // Store token in localStorage for the broker component to use
      localStorage.setItem('kite_request_token', requestToken || '');
      
      // Clean up URL
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      
      // Show success toast
      toast.success('Zerodha connection initiated. Please continue in your profile.');
    }
    
    // Also check for error
    if (params.has('status') && params.get('status') === 'error') {
      const errorMessage = params.get('message') || 'Unknown error';
      console.error('Zerodha error:', errorMessage);
      
      // Store error in localStorage
      localStorage.setItem('kite_error_message', errorMessage);
      
      // Clean up URL
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      
      // Show error toast
      toast.error(`Zerodha connection error: ${errorMessage}`);
    }
  }, [location]);

  return null;
};

export default ZerodhaConnectionHandler;
